export default "__VITE_PUBLIC_ASSET__c5e48a9d__"